import { DEFAULT_PAGE, PaginationMetaDto } from "@bondsports/types";
export const DEFAULT_RESOURCE_QTY = 1;
export const DEFAULT_RESOURCES_PER_PAGE = 10;
export const DEFAULT_EMPTY_META = { meta: {} as PaginationMetaDto };
export const DEFATULT_RESPONSE_META: PaginationMetaDto = {
	totalItems: 0,
	itemsPerPage: DEFAULT_RESOURCES_PER_PAGE,
	totalPages: DEFAULT_PAGE,
	currentPage: 0,
};
export const DEFAULT_LINE_HEIGHT = 100;
export const LIST_HEIGHT_OFFSET = 65;
